import { FC, HTMLAttributes } from "react";
import FireIcon from "../../../assets/reward/fire.svg";
import FireIconOn from "../../../assets/reward/bold_fire_1x.webp";
import FireIconOn2x from "../../../assets/reward/bold_fire_2x.webp";
import FireIconOn3x from "../../../assets/reward/bold_fire_3x.webp";
import StreakStar from "../../../assets/reward/streak_stars.svg";
import RewardBoxOpenIcon from "../../../assets/reward/reward-box-open.svg";
import RewardBoxIcon from "../../../assets/reward/reward-box.svg";
import ShineEffect from "../../../assets/reward/shine-effect.png";
import { useStyles } from "./DailyStreakAnimation.style";
import clsx from "classnames";
import { Typography, TypographyVariant, Image } from "../../../core";
import { GemNumber } from "../../GemNumber/GemNumber";
import { useTranslation } from "react-i18next";

interface IDailyStreakAnimationProps {
  streak: number;
  reward: number;
}

export const DailyStreakAnimation: FC<
  IDailyStreakAnimationProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const { streak, reward } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={clsx(classes.rewardBoxContainer, "streak")}>
        <div className={classes.streakContainer}>
          <div className={clsx(classes.streak, "preStreak")}>
            <Image src={FireIcon} className={clsx(classes.fireIcon, "pre")} />
            {streak}
          </div>
          <div className={clsx(classes.streak, "currentStreak")}>
            <Image
              src={FireIconOn}
              src2x={FireIconOn2x}
              src3x={FireIconOn3x}
              className={clsx(classes.fireIcon, "current")}
            />
            <Image src={StreakStar} className={classes.streakStar} />
            <span className={classes.streakNumber}>{streak + 1}</span>
          </div>
        </div>
        <Typography variant={TypographyVariant.HeadingH6Bold}>
          {t("common_days in a row")}
        </Typography>
      </div>
      <GemNumber amount={reward} gemSize={40} className={classes.gemNumber} />
      <Image src={ShineEffect} className={classes.shineEffect} />
      <Image src={RewardBoxOpenIcon} className={classes.rewardBoxOpen} />
      <Image src={RewardBoxIcon} className={classes.rewardBox} />
    </div>
  );
};
